module.exports = __webpack_public_path__ + "img/block.542f6457.png";